export default "__VITE_ASSET__B2UPrMBu__"